export enum CountriesEnum {
    Usa = "1",
    Colombia = "2",
    Honduras = "3",
    Panama = "4"
}